import React, { useEffect } from "react";
import axios from "axios";
import { KAKAO_TOKEN_URL, POST_KAKAO_SIGNIN_URL } from "@libs/apiUrl";
import { Navigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

const KakaoRedirect = () => {
  const code = new URL(window.location.href).searchParams.get("code");

  // 1. 카카오 토큰 받기
  const kakaoTokenMutation = useMutation({
    mutationFn: async () => {
      const { data } = await axios.post(
        KAKAO_TOKEN_URL,
        `grant_type=authorization_code&client_id=${process.env.REACT_APP_KAKAO_REST_API_KEY}&redirect_uri=${process.env.REACT_APP_KAKAO_REDIRECT_URI}&code=${code}`,

        {
          headers: {
            "Content-type": "application/x-www-form-urlencoded;charset=utf-8",
          },
        },
      );

      return data.access_token;
    },
    onSuccess: (accessToken) => {
      // 카카오 토큰 받기 성공하면 서버에 토큰 post
      serverLoginMutation.mutate(accessToken);
    },
  });

  // 2. 서버 로그인
  const serverLoginMutation = useMutation({
    mutationFn: async (accessToken: string) => {
      const fcmToken = window.android?.getFCMToken() || "";

      const { data: serverData, headers } = await axios.post(
        POST_KAKAO_SIGNIN_URL,
        {
          access_token: accessToken,
          fcm_token: fcmToken,
        },
      );
      // 헤더에 토큰 있는 경우 (가입 유저)
      const isRegistered = !!headers.authorization;

      // 가입된 유저인 경우 토큰을 localStorage에 저장
      if (isRegistered && headers.authorization) {
        localStorage.setItem("accessToken", headers.authorization);
        localStorage.setItem("loginType", "KAKAO"); // 여기에 추가
      }

      return {
        data: serverData.data,
        isRegistered,
      };
    },
  });

  useEffect(() => {
    if (code) {
      kakaoTokenMutation.mutate();
    }
  }, []);

  return serverLoginMutation.isSuccess ? (
    serverLoginMutation.data.isRegistered ? (
      <Navigate to="/" />
    ) : (
      <Navigate
        to="/join"
        state={{
          login_type: serverLoginMutation.data.data.oauth_provider,
          userData: serverLoginMutation.data.data,
        }}
      />
    )
  ) : null;
};

export default KakaoRedirect;
